import { lazy, Suspense } from 'react';
import { Badge, Collapse } from 'core/components/ui';
import type { AssignmentsHistoryType, UserMember } from 'core/types';
import { Card } from './HistoryCollapse.styles';

const History = lazy(() => import('../History'));

const { Panel } = Collapse;

interface Props {
  history: AssignmentsHistoryType[];
  users: UserMember[];
}

function HistoryCollapse(props: Props): JSX.Element | null {
  const { history } = props;

  const count = history && history.length > 0 ? history.length : 0;
  const header = (
    <Badge status="success" size="small" count={count}>
      <span style={{ paddingRight: '10px' }}>History</span>
    </Badge>
  );

  return count ? (
    <Card className="card my-3">
      <Collapse>
        <Panel key="1" header={header}>
          <Suspense fallback={<div>Loading...</div>}>
            <History {...props} />
          </Suspense>
        </Panel>
      </Collapse>
    </Card>
  ) : null;
}

export default HistoryCollapse;
